module.exports = __webpack_public_path__ + "static/media/ep-liitto.6074ba19.svg";